import React from "react";
import InputMask from "react-input-mask";

export default class Submit extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      handleChange,
      handleSubmit,
      holderName,
      number,
      expMonth,
      expYear,
      cvv2,
      active,
      formErrors,
      handleCloseSection,
      showErrors
    } = this.props;
    return (
      <div>
        <div className="modal-bg" />

        <div className="modal">
          {/* Header */}
          <div className="head-general with-back">
            <a href="javascript: void(0)" className="back" />
            <h4>New Card</h4>
            <a
              href="javascript: void(0)"
              onClick={e => handleCloseSection(e)}
              className="close"
            >
              <i className="icon icon-close" />
            </a>
          </div>
          {/* Header */}

          <div className="modal-body">
            <div className="row center-sm">
              <div className="col-sm-8">
                <div className="add-card-form">
                  <form onSubmit={handleSubmit}>
                    <div className="white-bg">
                      <div
                        className={`form-group sticky-form-label ${(showErrors &&
                          formErrors["number"] &&
                          "error") ||
                          ""}`}
                      >
                        <InputMask
                          mask="9999-9999-9999-9999"
                          id="number"
                          onChange={handleChange}
                          className={`form-input ${(number && "active") || ""}`}
                        />

                        <label htmlFor="number">Card Number</label>
                        <span>
                          {(showErrors &&
                            formErrors["number"] &&
                            formErrors["number"]) ||
                            ""}
                        </span>
                      </div>
                      <div
                        className={`form-group sticky-form-label ${(showErrors &&
                          formErrors["holderName"] &&
                          "error") ||
                          ""}`}
                      >
                        <input
                          onChange={handleChange}
                          className={`form-input ${(holderName && "active") ||
                            ""}`}
                          type="text"
                          id="holderName"
                        />
                        <label htmlFor="holderName">Card Holder</label>
                        <span>
                          {(showErrors &&
                            formErrors["holderName"] &&
                            formErrors["holderName"]) ||
                            ""}
                        </span>
                      </div>
                      <div className="d-flex justify-content-around align-items-center">
                        <div className="expire-date">
                          <div className="d-flex justify-content-around align-items-center">
                            <div
                              className={`form-group sticky-form-label ${(showErrors &&
                                formErrors["expMonth"] &&
                                "error") ||
                                ""}`}
                            >
                              <input
                                onChange={handleChange}
                                className={`form-input ${(expMonth &&
                                  "active") ||
                                  ""}`}
                                id="expMonth"
                                maxLength="2"
                                type="number"
                                onKeyPress={evt => {
                                  if (
                                    (evt.which != 8 &&
                                      evt.which != 0 &&
                                      evt.which < 48) ||
                                    evt.which > 57
                                  ) {
                                    evt.preventDefault();
                                  }
                                  if (
                                    evt.target.value &&
                                    evt.target.value.length === 2
                                  ) {
                                    evt.preventDefault();
                                  }
                                }}
                              />
                              <label htmlFor="expMonth">Month</label>
                              <span>
                                {(showErrors &&
                                  formErrors["expMonth"] &&
                                  formErrors["expMonth"]) ||
                                  ""}
                              </span>
                            </div>

                            <div
                              className={`form-group sticky-form-label ${(showErrors &&
                                formErrors["expYear"] &&
                                "error") ||
                                ""}`}
                            >
                              <input
                                onChange={handleChange}
                                className={`form-input ${(expYear &&
                                  "active") ||
                                  ""}`}
                                onKeyPress={evt => {
                                  if (
                                    (evt.which != 8 &&
                                      evt.which != 0 &&
                                      evt.which < 48) ||
                                    evt.which > 57
                                  ) {
                                    evt.preventDefault();
                                  }
                                  if (
                                    evt.target.value &&
                                    evt.target.value.length === 4
                                  ) {
                                    evt.preventDefault();
                                  }
                                }}
                                type="number"
                                id="expYear"
                                maxLength="4"
                              />
                              <label htmlFor="expYear">Year</label>
                              <span>
                                {(showErrors &&
                                  formErrors["expYear"] &&
                                  formErrors["expYear"]) ||
                                  ""}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`form-group sticky-form-label ${(showErrors &&
                            formErrors["cvv2"] &&
                            "error") ||
                            ""}`}
                        >
                          <input
                            onChange={handleChange}
                            className={`form-input ${(cvv2 && "active") || ""}`}
                            type="number"
                            onKeyPress={evt => {
                              if (
                                (evt.which != 8 &&
                                  evt.which != 0 &&
                                  evt.which < 48) ||
                                evt.which > 57
                              ) {
                                evt.preventDefault();
                              }
                              if (
                                evt.target.value &&
                                evt.target.value.length === 4
                              ) {
                                evt.preventDefault();
                              }
                            }}
                            id="cvv2"
                          />
                          <label htmlFor="cvv2">CVV</label>
                          <span>
                            {(showErrors &&
                              formErrors["cvv2"] &&
                              formErrors["cvv2"]) ||
                              ""}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="use-buttons">
                      <button
                        className={(active && "btn btn-blue") || "btn btn-gray"}
                        type="submit"
                      >
                        <span>Save</span>
                      </button>
                    </div>
                  </form>
                </div>
                {/* .add-card-form */}
              </div>
              {/* .col-sm-8 */}
            </div>
            {/* .row */}
          </div>
          {/* .modal-body */}
        </div>
        {/* .modal */}
      </div>
    );
  }
}
